import React, { Component } from "react";

import Menu from "./pages/Menu";
import PaymentResult from "./pages/PaymentResult";
import Main from "./pages/Main";
import InvoiceInfo from "./pages/InvoiceInfo";
import Notfound from "./pages/NotFound";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-toastify/dist/ReactToastify.css";

//import 'jquery.prettyPhoto.min.js';
import "./App.css";

export default class App extends Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Switch>
            <Route exact path="/invoiceInfo/:id" component={InvoiceInfo} />
            <Route exact path="/NotFound" component={Notfound} />
            <Route path="/:code/:id/PaymentResult" component={PaymentResult} />
            <Route path="/:code/:id" component={Menu} />
            <Route path="/:code" component={Menu}></Route>
            <Route exact path="/" component={Main} />
          </Switch>
        </BrowserRouter>
        {/* <BrowserRouter>
          <Route exact path="/FactureInfo/:id" component={FactureInfo} />
          <Route exact path="/:code/:id" component={Menu} />
          <Route exact path="/:code" component={Menu}></Route>

          <Route exact path="/" component={Main} />
          <Route exact path="/NotFound" component={Notfound} />
        </BrowserRouter> */}
        <ToastContainer transition={Slide} />
      </div>
    );
  }
}
